import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ButtonLink } from 'components/shared/ButtonLink';
import { useI18n } from 'hooks/useI18n';
import {
  StyledHero,
  StyledHeroContainer,
  StyledHeroText,
  StyledHeroTitle,
  StyledHeroVideo,
  StyledHeroVideoContainer
} from './MGMHero.styled';

const MGMHero: React.FC = () => {
  const { t } = useI18n('member-get-member');

  return (
    <StyledHero>
      <StyledHeroContainer>
        <StyledHeroText>
          <StyledHeroTitle>{t('member-get-member.hero.title')}</StyledHeroTitle>
          <p
            dangerouslySetInnerHTML={{
              __html: t('member-get-member.hero.desc')
            }}
          ></p>
          <ButtonLink href="#features" variant="brandTalent">
            <FontAwesomeIcon icon={faCheckCircle} />
            <span>{t('member-get-member.hero.cta')}</span>
          </ButtonLink>
        </StyledHeroText>
        <StyledHeroVideoContainer>
          <StyledHeroVideo>
            <iframe
              src="https://player.vimeo.com/video/810841213?h=d60b4cb5b5&autoplay=1&title=0&byline=0&portrait=0&muted=1"
              frameBorder="0"
              allow="autoplay; fullscreen; picture-in-picture"
              allowFullScreen
            ></iframe>
          </StyledHeroVideo>
        </StyledHeroVideoContainer>
      </StyledHeroContainer>
    </StyledHero>
  );
};

export default MGMHero;
